import React from 'react'
import { useParams } from 'react-router'
import { useStates } from '../../hooks/CompanyConfiguration/useStates'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import StateView from '../../components/version-4/viewForms/StateView'
import { ROUTES } from '../../shared/constants'

function ViewState() {
  const { states, getStates } = useStates()
  const params = useParams()
  React.useEffect(() => {
    getStates({ stateId: params.stateId })
  }, [params.stateId])

  return (
    <Layout heading="State" heading2="Info" url1={ROUTES.STATE} none>
      {states ? (
        <HeaderTabLayout
          heading="State"
          content={<StateView state={states} />}
          view
          url={`/edit-state/${params.stateId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewState
